import validate from "/tmp/build/d411e185/code/node_modules/nuxt/dist/pages/runtime/validate.js";
import normalize_45locale_45global from "/tmp/build/d411e185/code/middleware/normalize-locale.global.ts";
import redirect_45lang_45global from "/tmp/build/d411e185/code/middleware/redirect-lang.global.ts";
import manifest_45route_45rule from "/tmp/build/d411e185/code/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  normalize_45locale_45global,
  redirect_45lang_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}